<div class="-mb-14">
  <ng-container *ngIf="type === 'free'">
    <div class="mb-14">
      <gtd-pql-editor [formControl]="controlByName('pql')" [conditions]="conditions"></gtd-pql-editor>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'country'">
    <div class="mb-14">
      <p500-ui-select-with-icon-field [formControl]="controlByName('country')" label="Countries" [data]="countriesData" [multiple]="true">
      </p500-ui-select-with-icon-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'affiliate'">
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('affiliateUUID')"
        label="Affiliates"
        [data]="globalData.affiliates"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'offer'">
    <div class="mb-14">
      <p500-ui-select-field [formControl]="controlByName('offerUUID')" label="Offers" [data]="globalData.offers" [multiple]="true">
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'affiliateOffer'">
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('affiliateUUID')"
        label="Affiliates"
        [data]="globalData.affiliates"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
    <div class="mb-14">
      <p500-ui-select-field [formControl]="controlByName('offerUUID')" label="Offers" [data]="globalData.offers" [multiple]="true">
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'countryAffiliate'">
    <div class="mb-14">
      <p500-ui-select-with-icon-field [formControl]="controlByName('country')" label="Countries" [data]="countriesData" [multiple]="true">
      </p500-ui-select-with-icon-field>
    </div>
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('affiliateUUID')"
        label="Affiliates"
        [data]="globalData.affiliates"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'countryOffer'">
    <div class="mb-14">
      <p500-ui-select-with-icon-field [formControl]="controlByName('country')" label="Countries" [data]="countriesData" [multiple]="true">
      </p500-ui-select-with-icon-field>
    </div>
    <div class="mb-14">
      <p500-ui-select-field [formControl]="controlByName('offerUUID')" label="Offers" [data]="globalData.offers" [multiple]="true">
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'countryAffiliateOffer'">
    <div class="mb-14">
      <p500-ui-select-with-icon-field [formControl]="controlByName('country')" label="Countries" [data]="countriesData" [multiple]="true">
      </p500-ui-select-with-icon-field>
    </div>
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('affiliateUUID')"
        label="Affiliates"
        [data]="globalData.affiliates"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
    <div class="mb-14">
      <p500-ui-select-field [formControl]="controlByName('offerUUID')" label="Offers" [data]="globalData.offers" [multiple]="true">
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'affiliateAffSub'">
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('affiliateUUID')"
        label="Affiliates"
        [data]="globalData.affiliates"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('affSubX')" label="AffiliateSub X" [data]="affSubData"> </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-text-field [formControl]="controlByName('affSub')" label="AffiliateSub Value"> </p500-ui-text-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'affSubAffSource'">
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('affSubX')" label="AffiliateSub X" [data]="affSubData"> </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-text-field [formControl]="controlByName('affSub')" label="AffiliateSub Value"> </p500-ui-text-field>
        </div>
      </div>
    </div>
    <div class="mb-14">
      <p500-ui-text-field [formControl]="controlByName('affiliateSource')" label="Affiliate Source"> </p500-ui-text-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'dayOfWeek'">
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('dayOfWeekFrom')" label="From Day" [data]="daysData"> </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('dayOfWeekTo')" label="To Day" [data]="daysData"> </p500-ui-select-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'hourOfDay'">
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('hourOfDayFrom')" label="From Hour" [data]="hoursFromData">
          </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('hourOfDayTo')" label="To Hour" [data]="hoursToData"> </p500-ui-select-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'dayOfWeekHourOfDay'">
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('dayOfWeekFrom')" label="From Day" [data]="daysData"> </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('dayOfWeekTo')" label="To Day" [data]="daysData"> </p500-ui-select-field>
        </div>
      </div>
    </div>
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('hourOfDayFrom')" label="From Hour" [data]="hoursFromData">
          </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('hourOfDayTo')" label="To Hour" [data]="hoursToData"> </p500-ui-select-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'advertiser'">
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('advertiserUUID')"
        label="Advertisers"
        [data]="globalData.advertisers"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'advertiserCountry'">
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('advertiserUUID')"
        label="Advertisers"
        [data]="globalData.advertisers"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
    <div class="mb-14">
      <p500-ui-select-with-icon-field [formControl]="controlByName('country')" label="Countries" [data]="countriesData" [multiple]="true">
      </p500-ui-select-with-icon-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'offerUrl'">
    <div class="mb-14">
      <div class="row">
        <div class="col-6">
          <p500-ui-select-field [formControl]="controlByName('offerUUID')" label="Offer" [data]="globalData.offers"> </p500-ui-select-field>
        </div>
        <div class="col-6">
          <p500-ui-select-field
            [formControl]="controlByName('offerURLUUID')"
            label="Offer URL"
            [data]="offersUrlsDependentData"
            [multiple]="true"
          >
          </p500-ui-select-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="targetTags[type] as label">
    <div class="mb-14">
      <p500-ui-text-field [formControl]="form.controls[type]" [label]="label"> </p500-ui-text-field>
    </div>
  </ng-container>

  <ng-container *ngIf="type === 'goalType'">
    <div class="mb-14">
      <p500-ui-select-field
        [formControl]="controlByName('goalTypeUUID')"
        label="Goal Type"
        [data]="globalData.goal_types"
        [multiple]="true"
      >
      </p500-ui-select-field>
    </div>
  </ng-container>
</div>
